import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Spinner from 'components/Spinner';
import MetricsTableMPA from 'components/MetricsTable/MPAMetricsTable';
import useFetch from 'hooks/useFetch';
import apiRoutes from 'config/apiRoutes';
import { useAuth0 } from '@auth0/auth0-react';

const MetricsMPA = ({ metricSourceId, metricName, metricSourceEnabled }) => {
    const { getAccessTokenSilently, logout } = useAuth0();
    const request = useFetch(getAccessTokenSilently, logout);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [usedByCustomersList, setUsedByCustomersList] = useState([]);
    const [isMetricSourceEnabled, setIsMetricSourceEnabled] = useState(
        metricSourceEnabled
    );
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [metrics, setMetrics] = useState([]);

    const toggleModalVisible = () => {
        setIsModalVisible(!isModalVisible);
    };

    const handleSuccessMetrics = (res) => {
        setMetrics(res.metrics);
        setIsLoading(false);
    };

    const handleFailureMetrics = (err) => {
        setIsLoading(false);
        return err;
    };

    const fetchMetrics = () => {
        setIsLoading(true);
        request(
            apiRoutes.get.mpaMetricsBySourceId(metricSourceId),
            'GET',
            handleSuccessMetrics,
            handleFailureMetrics,
            {},
            { 'Content-Type': 'application/json' }
        );
    };

    const reloadMetrics = () => {
        setIsAccordionOpen(true);
        fetchMetrics();
    };

    const handleSuccessCustomers = (res) => {
        setUsedByCustomersList(res.organizations);
    };

    const handleFailureCustomers = (err) => err;

    const fetchCustomers = () => {
        request(
            `${apiRoutes.get.customers()}?metric_source_id=${metricSourceId}`,
            'GET',
            handleSuccessCustomers,
            handleFailureCustomers,
            {},
            { 'Content-Type': 'application/json' }
        );
    };

    const handleSuccessChangeSourceStatus = (res) => {
        if (!res.error) {
            setIsMetricSourceEnabled(!isMetricSourceEnabled);
        }
        fetchMetrics();
    };

    const handleFailureChangeSourceStatus = (err) => {
        fetchMetrics();
        return err;
    };

    const fetchChangeSourceStatus = (status) => {
        request(
            apiRoutes.put.mpaUpdateMetricSource(metricSourceId),
            'PUT',
            handleSuccessChangeSourceStatus,
            handleFailureChangeSourceStatus,
            {
                body: JSON.stringify({
                    metric_source: {
                        enabled: status,
                    },
                }),
            },
            { 'Content-Type': 'application/json' }
        );
    };

    useEffect(() => {
        fetchMetrics();
    }, [metricSourceId]);

    useEffect(() => {
        fetchCustomers();
    }, [isModalVisible]);

    if (isLoading) {
        return <Spinner />;
    }

    return (
      <MetricsTableMPA
            label={metricName}
            metrics={metrics}
            metricSourceId={metricSourceId}
            isMetricSourceEnabled={isMetricSourceEnabled}
            isModalVisible={isModalVisible}
            toggleModalVisible={toggleModalVisible}
            usedByCustomersList={usedByCustomersList}
            reloadMetrics={reloadMetrics}
            isAccordionOpen={isAccordionOpen}
            fetchChangeSourceStatus={fetchChangeSourceStatus}
            refresh={fetchMetrics}
        />
    );
};

MetricsMPA.propTypes = {
    metricSourceId: PropTypes.string.isRequired,
    metricName: PropTypes.string.isRequired,
    metricSourceEnabled: PropTypes.bool.isRequired,
};

export default MetricsMPA;
